import { Action as ReduxAction } from 'redux';

import { BackgroundJobAllowedActions } from '~src/backgroundJob/types/BackgroundJobAllowedActions';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { IDatasourceActions } from '~src/datasource/ServerApi/types/IDatasourceActions';
import { FlowAllowedActions } from '~src/flow/serverApi/types/FlowAllowedActions';
import { IProjectActions } from '~src/projects/ServerApi/types/IProjectActions';
import { ResourceGovernanceAllowedActions } from '~src/schedule/types/ResourceGovernanceService';
import { IViewActions } from '~src/views/ServerApi/types/IViewActions';
import { IWorkbookActions } from '~src/workbook/ServerApi/types/IWorkbookActions';

import { SourceComponentType } from '../ActionsMenu';


export enum EntityActionNames {
  AccelerateWorkbook = 'AccelerateWorkbook',
  AcknowledgeUserIdentityConflict = 'AcknowledgeUserIdentityConflict',
  ActivateSite = 'activate-site',
  AddToCollections = 'add-to-collections',
  CancelBackgroundJob = 'cancelBackgroundJob',
  ViewBackgroundJobDetails = 'viewBackgroundJobDetails',
  ChangeExtractDsToLive = 'change_extract_ds_to_live',
  ChangeExtractDsToLiveEmb = 'change_extract_ds_to_live_emb',
  TasksChangeSchedule = 'tasks-change-schedule',
  TasksEdit = 'tasks-edit',
  TasksEditExpectedDuration = 'tasks-edit-expected-duration',
  SubscriptionChangeDataSetting = 'subscription-change-data-setting',
  TasksChangeSubject = 'tasks-change-subject',
  SubscriptionChangeFormat = 'subscription-change-format',
  SubscriptionChangeFrequency = 'subscription-change-frequency',
  CollectionDetails = 'collection-details',
  ConnectedApplicationDetails = 'connected-application-details',
  ConnectedApplicationToggleEnablement = 'connected-application-toggle-enablement',
  CopyLuid = 'copy-luid',
  CreateExtractsEncrypted = 'create_extracts_encrypted',
  CreateExtractsUnencrypted = 'create_extracts_unencrypted',
  CreateExtracts = 'create_extracts',
  CreateExtractsEmbEncrypted = 'create_extracts_emb_encrypted',
  CreateExtractsEmbUnencrypted = 'create_extracts_emb_unencrypted',
  CreateExtractsEmb = 'create_extracts_emb',
  CreateFlowSubscription = 'create_flow_subscription',
  AddSelf = 'addSelf',
  Edit = 'edit',
  EditDatasource = 'edit_datasource',
  RemoveSelf = 'removeSelf',
  Resume = 'resume',
  Decrypt = 'decrypt',
  Delete = 'delete',
  DeleteForever = 'deleteForever',
  DisableWorkbookAcceleration = 'disableWorkbookAcceleration',
  TasksDelete = 'tasks-delete',
  DiscardDraft = 'discard-draft',
  Download = 'download',
  Move = 'move',
  NewFlow = 'new_flow',
  NewWorkbook = 'new_workbook',
  RefreshExtracts = 'refresh_extracts',
  RemoveExternalContent = 'removeExternalContent',
  RemoveFromThisCollection = 'remove-from-this-collection',
  Rename = 'rename',
  TasksResumeExtractRefresh = 'tasks-resume-extract-refresh',
  SubscriptionResume = 'subscription-resume',
  RevisionHistory = 'revision_history',
  TasksRunNow = 'tasks-run-now',
  RunNow = 'runNow',
  TasksPriority = 'tasks-priority',
  TasksResume = 'tasks-resume',
  DisableSchedules = 'disableSchedules',
  EditGroup = 'edit-group',
  EditGroupSet = 'edit-groupSet',
  EditSchedule = 'edit-schedule',
  EnableSchedules = 'enableSchedules',
  ScheduleFlowTaskSubmenu = 'ScheduleFlowTaskSubmenu',
  ScheduleLinkedTask = 'ScheduleLinkedTask',
  ScheduleSingleFlowTask = 'ScheduleSingleFlowTask',
  SchedulesRunNow = 'schedules-run-now',
  SetCertification = 'setCertification',
  SetCustomDataLabel = 'setCustomDataLabel',
  SetSensitiveDataLabel = 'setSensitiveDataLabel',
  SetLabelValue = 'setLabelValue',
  SetAiDataLabel = 'setAiDataLabel',
  SetContact = 'setContact',
  AddFavorite = 'addFavorite',
  RemoveFavorite = 'removeFavorite',
  DataQualityMenu = 'dataQualityMenu',
  SetDataQuality = 'setDataQuality',
  SetDataQualityTrigger = 'setDataQualityTrigger',
  DataQualitySubmenu = 'dataQualitySubmenu',
  DataLabelsSubmenu = 'dataLabelsSubmenu',
  SetDescription = 'setDescription',
  SetDisplayTabs = 'setDisplayTabs',
  SetOwner = 'setOwner',
  Permissions = 'permissions',
  SetTags = 'setTags',
  ShareContent = 'shareContent',
  SuspendSite = 'suspend-site',
  UnsubscribeSubscriptions = 'unsubscribe-subscriptions',
  WhoHasSeenThisView = 'who_has_seen_this_view',
  EditDataConnection = 'edit_data_connection',
  EditFlow = 'editFlow',
  EditPublishedConnection = 'editPublishedConnection',
  PublishedConnectionTableExtractsRefreshNow = 'PublishedConnectionTableExtractsRefreshNow',
  EditSiteSettings = 'edit-site-settings',
  Encrypt = 'encrypt',
  ExtractsEncrptionEncrypted = 'extracts_encrption_encrypted',
  ExtractsEncrptionUnencrypted = 'extracts_encrption_unencrypted',
  ExtractsEncrptionAction = 'extracts_encrption_action',
  HideRecommendation = 'hideRecommendation',
  SiteUserSiteRole = 'siteuser-siteRole',
  SiteUserRemove = 'siteuser-remove',
  SiteUserRemoveFromGroup = 'siteuser-remove-group',
  SiteUserEditGroupMembership = 'siteuser-groupMembership',
  SiteUserAuthentication = 'siteuser-authentication',
  SiteUserForcePasswordReset = 'siteuser-forcePasswordUpdate',
  SiteUserResetLoginRateLimiting = 'siteuser-resetLoginRateLimiting',
  SiteUserResetMFA = 'siteuser-resetMFA',
  SiteUserAddToIdentityPool = 'SiteUserAddToIdentityPool',
  SiteUserRemoveFromIdentityPool = 'SiteUserRemoveFromIdentityPool',
  ServerUserDeleteUsers = 'serveruser-delete',
  ServerUserEditSiteMembership = 'serveruser-siteMembership',
  ServerUserForcePasswordReset = 'serveruser-forcePasswordUpdate',
  ServerUserResetLoginRateLimiting = 'serveruser-resetLoginRateLimiting',
  ServerUserAddToIdentityPool = 'ServerUserAddToIdentityPool',
  ServerUserRemoveFromIdentityPool = 'ServerUserRemoveFromIdentityPool',
  SynchronizeGroup = 'sync-group',
  SynchronizeGroups = 'sync-groups',
  UpdateGroupMinimumSiteRole = 'update-group-site-role',
  UpdateGroupGrantLicenseMode = 'update-group-grant-license-mode',
  DeleteGroup = 'delete-group',
  GroupDatabases = 'group-databases',
  UngroupDatabases = 'ungroup-databases',
  ScheduleRefreshWithBridge = 'schedule-refresh-with-bridge',
  OpenWorkbookInDesktop = 'open-workbook-in-desktop',
  Share = 'share',
  GroupRemoveFromGroupSet = 'group-remove',
  EnableLinkedTask = 'enable-linked-tasks',
  DisableLinkedTask = 'disable-linked-tasks',
  DataAccelerationSubmenu = 'DataAccelerationSubmenu',
  AdminProfileRemoveFromSite = 'admin-profile-remove-from-site',
  AdminProfileSiteMembership = 'admin-profile-site-membership',
  AdminProfileRemoveFromUser = 'admin-profile-remove-from-user',
  AdminAllowDataAcceleration = 'AdminAllowDataAcceleration',
  AdminDisallowDataAcceleration = 'AdminDisallowDataAcceleration',
  DataAccelerationOn = 'DataAccelerationOn',
  DataAccelerationOff = 'DataAccelerationOff',
  UpdateDataFreshnessPolicy = 'UpdateDataFreshnessPolicy',
  ReevaluateUserIdentityConflict = 'ReevaluateUserIdentityConflict',
  ResourceGovernanceResetSiteToDefaultsAction = 'resourceGovernanceResetSiteToDefaultsAction',
  ResourceGovernanceEditSiteAction = 'resourceGovernanceEditSiteAction',
  Restore = 'restoreAction',
  RetryUserIdentityMigration = 'RetryUserIdentityMigration',
  ResolveAmbiguousUserIdentityConflict = 'ResolveAmbiguousUserIdentityConflict',
  PublishToSalesforce = 'PublishToSalesforce',
  RevertToDefaultLabel = 'RevertToDefaultLabel',
  GeocodeDatasource = 'geocode-datasource',
  ExtractFailureNotification = 'extract_failure_notification',
  ExtractFailureNotificationOptIn = 'extract_failure_notification_opt_in',
  ExtractFailureNotificationOptOut = 'extract_failure_notification_opt_out',
}

/**
 * An action that can be performed on an entity (content item, user, group, subscription, etc.).
 */
export interface IEntityAction<TItem, TAvailableActions> {
  name: EntityActionNames;
  parentName?: string;
  resourcePermission?: { resourceType: string, resourceActions: string[] };
  translateName(targetItems?: TItem[], state?: AppState): string; // A `Messages` function
  isVisible(targetItems: TItem[], state: AppState, availableActions?: TAvailableActions | undefined, sourceComponent?: SourceComponentType): boolean;
  isClickable(availableActions: TAvailableActions | undefined, targetItems: TItem[], state: AppState): boolean;
  createReduxAction(targetItems: TItem[]): ReduxAction;
  isChecked?: (availableActions: TAvailableActions, targetItems: TItem[], state: AppState) => boolean;
}


export type AvailableActionsForAllContentTypes =
  IWorkbookActions &
  IDatasourceActions &
  IProjectActions &
  IViewActions &
  FlowAllowedActions &
  BackgroundJobAllowedActions &
  ResourceGovernanceAllowedActions;

// Until we implement story 752767, which will check for permissions on actions of multiple content
// types, we're pretending the user has permission for all actions, so we pass this object into
// the entity actions, instead of the actual available actions from the server for a particular entity.

// NOTE: delForever and restore allowed state are not used to determine whether to render either as an option,
// rather those options only rely on the space (visible in menus in the Recycle Bin space). This check should
// be added when (if) the above story is addressed (752767).
export const AllActionsAllowed: { readonly [K in keyof AvailableActionsForAllContentTypes]: true } = {
  addComment: true,
  cancelBackgroundJob: true,
  createProject: true,
  decryptExtracts: true,
  del: true,
  delForever: true,
  download: true,
  encryptExtracts: true,
  launchWebAuthoring: true,
  manageFlow: true,
  publishToSalesforce: true,
  refreshExtract: true,
  runFlow: true,
  seeComments: true,
  setConnection: true,
  setCertification: true,
  setDescription: true,
  setDisplayTabs: true,
  setName: true,
  setOwner: true,
  setPermissions: true,
  setProject: true,
  setTags: true,
  versionManagement: true,
  updateRemoveDataQuality: true,
  sendEmail: true,
  createExtracts: true,
  extractsToLive: true,
  webEditFlow: true,
  share: true,
  whoHasSeenThisView: true,
  editDatasource: true,
  editAllowedPublishedDatasource: true,
  enableAcceleration: true,
  disableAcceleration: true,
  editDataFreshnessPolicy: true,
  createSubscription: true,
  editResourceGovernanceSite: true,
  resetSiteResourceGovernanceSite: true,
  restore: true,
  allowExtractRefresh: true,
  isExtractFailureNotificationEnabled: true
};
